/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsbusinesses1Inputs */

const en_statsbusinesses1 = /** @type {(inputs: Statsbusinesses1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Businesses`)
};

const de_statsbusinesses1 = /** @type {(inputs: Statsbusinesses1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

/**
* | output |
* | --- |
* | "Businesses" |
*
* @param {Statsbusinesses1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsbusinesses1 = /** @type {((inputs?: Statsbusinesses1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsbusinesses1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsbusinesses1(inputs)
	return de_statsbusinesses1(inputs)
});
export { statsbusinesses1 as "statsBusinesses" }